import React from 'react';
import { CheckCircle2, Route, Smartphone, TrendingUp, Truck, BarChart3, Camera } from 'lucide-react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const ZartooAppPage = () => {
  const modules = [
    { title: 'Vendas Mobile', icon: Smartphone, items: ['Pré-venda e pronta entrega', 'Sugestão de compras', 'Tabelas de preço', 'Bonificações'] },
    { title: 'Entregas GPS', icon: Truck, items: ['Monitoramento em tempo real', 'Roteiros otimizados', 'Prestação de contas', 'Retorno de vendas'] },
    { title: 'Trade Marketing', icon: Camera, items: ['Registro fotográfico', 'Check-list de visitas', 'Metas por PDV', 'Ruptura de produtos'] },
    { title: 'BI Mobile', icon: BarChart3, items: ['Indicadores em tempo real', 'Ranking de vendedores', 'Metas vs realizado', 'Faturamento diário'] }
  ];

  return (
    <div>
      <PageHero
        eyebrow="Zartoo APP"
        title="Venda mais com força de vendas 100% offline."
        subtitle="Rotas inteligentes, pedidos rápidos e BI mobile para equipes externas."
        primaryCta={{ label: 'Testar o app', href: '/demonstracao' }}
        secondaryCta={{ label: 'Falar com especialista', href: '/especialista' }}
      />

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Desafios"
            title="Distribuição sem ruídos, mesmo sem internet"
            description="Reduza erros, atrasos e falta de visibilidade da equipe externa."
          />
          <div className="grid md:grid-cols-3 gap-6">
            {['Saldo de estoque incorreto', 'Rotas ineficientes', 'Altos custos operacionais'].map((item) => (
              <Card key={item}>
                <h3 className="text-xl font-semibold">{item}</h3>
                <p className="text-slate-200/80 mt-2">O app conecta sua operação ao ERP para evitar retrabalho.</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-900/80">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Módulos"
            title="4 módulos integrados no app"
            description="Tudo que sua força de vendas e entregas precisa em um único aplicativo."
          />
          <div className="grid md:grid-cols-2 gap-6">
            {modules.map((module) => (
              <Card key={module.title}>
                <div className="flex items-center gap-3 mb-3">
                  <module.icon className="w-6 h-6 text-[#FF6B35]" />
                  <h3 className="text-xl font-semibold">{module.title}</h3>
                </div>
                <ul className="space-y-1 text-sm text-slate-200/80">
                  {module.items.map((item) => (
                    <li key={item} className="flex items-center gap-2">
                      <CheckCircle2 className="w-4 h-4 text-[#FF6B35]" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white text-slate-900">
        <div className="container mx-auto px-8 lg:px-12 py-16">
          <SectionTitle
            eyebrow="Diferenciais"
            title="Funciona 100% offline"
            description="Sincronização automática com ERP, baixo consumo de bateria e interface intuitiva."
            mode="light"
          />
          <div className="grid md:grid-cols-3 gap-6">
            {['Offline-first', 'Rotas inteligentes', 'Resultados comprovados'].map((item) => (
              <Card key={item} variant="light">
                <TrendingUp className="w-6 h-6 text-[#1976D2]" />
                <h3 className="text-xl font-semibold mt-3">{item}</h3>
                <p className="text-slate-600 mt-2">Mais produtividade com controle total da equipe em campo.</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-950">
        <div className="container mx-auto px-8 lg:px-12 py-16 text-center">
          <SectionTitle
            eyebrow="Resultados"
            title="+20% vendas • -25% tempo • +30% positivação"
            description="Clientes usam o app para vender mais e gastar menos em deslocamento."
          />
          <a
            href="/demonstracao"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-black text-lg bg-[#FF6B35] text-white hover:shadow-orange-500/40 transition-all"
          >
            Solicitar demonstração
          </a>
        </div>
      </section>
    </div>
  );
};

export default ZartooAppPage;
